import React from 'react'

import Banner from '../components/Banner'
import Categories from '../components/Categories'
import ContentSection from '../components/ContentSection'
import TrialBanner from '../components/TrialBanner'
import DeviceBanner from '../components/DeviceBanner'
import Features from '../components/Features'
import CallToAction from '../components/CallToAction'
import Counter from '../components/Counter'
import Clients from '../components/Clients'
import Testimonials from '../components/Testimonials'

// Export Template for use in CMS preview
export const HomePageTemplate = ({ banner, categories, contentSection, trialBanner, features, callToAction, counters, clients, testimonials, deviceBanner }) => {
  const { counterLeft, counterRight } = counters

  return <main className="Home">
    <Banner 
      {...banner}
    >
      <Categories
        categories={categories}
      />
    </Banner>
    <ContentSection 
      {...contentSection}
    />
    <TrialBanner 
      {...trialBanner}
    />
    <Features 
      features={features}
    />
    <DeviceBanner
      {...deviceBanner}
    />
    <CallToAction 
      {...callToAction}
    />

    <section className='counters'>
      <div className='container'>
        <Counter 
          {...counterLeft}
        />
        <Counter 
          {...counterRight}
        />
      </div>
    </section>

    <Clients 
      {...clients}
    />

    <Testimonials 
      {...testimonials}
    />

  </main>
}

// Export Default HomePage for front-end
const HomePage = ({ data: { page, settingsYaml } }) => (
  <HomePageTemplate {...page} {...page.frontmatter} {...settingsYaml} body={page.html} />
)

export default HomePage

export const pageQuery = graphql`
  ## Query for HomePage data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query HomePage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        banner {
          buttonText
          buttonUrl
          description
          title
          subtitle
        }
        categories {
          title
          image {
            publicURL
          }
        }
        contentSection {
          buttonText
          buttonUrl
          content
          title
          video {
            publicURL
          }
        }
        features {
          title
          content
          image {
            publicURL
          }
        }
        callToAction {
          buttonText
          buttonUrl
          content
          title
          image {
            publicURL
          }
        }
        counters {
          counterLeft {
            description
            number
          }
          counterRight {
            description
            number
          }
        }
      }
    }
    settingsYaml {
      trialBanner {
        buttonText
        buttonUrl
        subtitle
        title
      }
      deviceBanner {
          content
          title
      }
      clients {
        content
        title
        client {
          image
          url
        }
      }
      testimonials {
        title
        testimonial {
          image
          name
          title
          content
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/HomePage.js